import { render } from "./Dh.vue?vue&type=template&id=30331a56&scoped=true"
import script from "./Dh.vue?vue&type=script&lang=js"
export * from "./Dh.vue?vue&type=script&lang=js"

import "./Dh.vue?vue&type=style&index=0&id=30331a56&lang=css"
import "./Dh.vue?vue&type=style&index=1&id=30331a56&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30331a56"]])

export default __exports__